import _extends from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import CommonFooter from '~/components/CommonFooter';
import CommonTitle from '~/components/CommonTitle';
export default {
  name: 'index',
  components: {
    CommonFooter: CommonFooter, CommonTitle: CommonTitle
  },
  data: function data() {
    return {
      idx: false,
      top: [{ top: '0px' }, { top: '0px' }, { top: '0px' }, { top: '0px' }],
      isShow: false,
      last: true,
      i: 0
    };
  },

  computed: _extends({}, mapState(['winHeight']), {
    up: function up() {
      return {
        height: this.winHeight - 60 + 'px'
      };
    },
    ups: function ups() {
      return {
        height: (this.winHeight - 60) * 2 + 'px'
      };
    }
  }),
  methods: {
    upTo: function upTo(index) {
      // this.top[index].top = -this.winHeight + 'px'

      // console.log(index)
      // let secondHeight = document.querySelector('.second-section')
      // if (index === 1) {
      //   console.dir(secondHeight)
      //   if (secondHeight.scrollTop > 213) {
      //     this.top[index].top = -this.winHeight + 'px'
      //   }
      // }
      // else if (index === 2 && secondHeight.clientHeight > - parseInt(secondHeight.style.top)) {

      //   this.top[1].top = -this.winHeight * 2 + 'px'
      //   this.i = 1
      // } 
      if (index === 3) {
        this.top[index].top = '-400px';
      } else if (index === 0) {
        this.top[index].top = -this.winHeight + 'px';
        document.querySelector('.second-section').scrollTop = 0;
      } else {
        this.top[index].top = -this.winHeight + 'px';
      }
      document.removeEventListener('mousewheel', this.mousewheel);
    },
    downTo: function downTo(index) {
      // let secondHeight = document.querySelector('.second-section')
      // if (index === 2 && secondHeight.clientHeight > - parseInt(secondHeight.style.top)) {
      //   this.top[1].top = -secondHeight.clientHeight + 'px'
      //   this.i = 1
      // } else 
      this.top[index].top = '0px';
      document.removeEventListener('mousewheel', this.mousewheel);
    },
    mousewheel: function mousewheel(e) {
      var _this = this;

      e = e || window.event;
      // console.dir(e.target.scrollTop)
      var wheelDelta = e.wheelDelta;
      // console.log(e, wheelDelta)
      // console.log(e.target.scrollTop)
      if (wheelDelta > 300) {
        this.downTo(this.i);
        setTimeout(function () {
          _this.i--;
          if (_this.i < 0) {
            _this.i = 0;
          }
          document.addEventListener('mousewheel', _this.mousewheel, false);
        }, 1000);
      } else {
        var node = document.querySelector('.second-wrap');
        if (wheelDelta < -300) {
          if (this.i === 1 && node.scrollTop + node.height == node.scrollHeight) {
            this.upTo(this.i);
            setTimeout(function () {
              _this.i++;
              if (_this.i > 3) {
                _this.i = 4;
              }
              document.addEventListener('mousewheel', _this.mousewheel, false);
            }, 1000);
          } else {
            this.upTo(this.i);
            setTimeout(function () {
              _this.i++;
              if (_this.i > 3) {
                _this.i = 3;
              }
              document.addEventListener('mousewheel', _this.mousewheel, false);
            }, 1000);
          }
        }

        // this.upTo(this.i)
        // setTimeout(() => {
        //   this.i++
        //   if (this.i > 3) {
        //     this.i = 3
        //   }
        //   document.addEventListener('mousewheel', this.mousewheel, false)
        // }, 1500)
      }
    },
    scroll: function scroll(e) {
      e.preventDefault();
    }
  },
  mounted: function mounted() {
    document.addEventListener('mousewheel', this.mousewheel, false);
    // document.querySelector('.first-section').addEventListener('scroll', this.scroll, false)
  },
  destoryed: function destoryed() {
    document.removeEventListener('mousewheel', this.mousewheel, false);
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/indexs.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/indexs.vue
// module chunks = 2